import React, { useState } from "react";
import { Avatar, Button, Modal, Tag, theme } from "antd";
import {
  EyeOutlined,
  UserOutlined,
  CalendarOutlined,
  TeamOutlined,
  FileTextOutlined,
  FlagOutlined
} from "@ant-design/icons";
import { PRIORITY_TAG, STATUS_TAG, formatTaskDate } from "./Tasks.constants";
import "./tasks.css";

import { useTranslation } from "react-i18next";

const InfoRow = ({ icon, label, children }) => (
  <div className="task-details__row">
    <div className="task-details__icon">{icon}</div>
    <div className="task-details__body">
      <p className="task-details__label">{label}</p>
      <div className="task-details__value">{children}</div>
    </div>
  </div>
);

const ShowDrawer = ({ item }) => {
  const { t } = useTranslation("dashboard");
  const { token } = theme.useToken();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const priorityTag = (
    <Tag color={PRIORITY_TAG[item?.priority] || PRIORITY_TAG.Medium} bordered={false}>
      {t(item?.priority)}
    </Tag>
  );
  const statusTag = (
    <Tag color={STATUS_TAG[item?.type] || STATUS_TAG.Pending} bordered={false}>
      {t(item?.type)}
    </Tag>
  );

  return (
    <>
      <Button
        type="text"
        size="small"
        className="desk-card__icon-btn"
        icon={<EyeOutlined />}
        aria-label={t("Task Details")}
        onClick={() => setIsModalOpen(true)}
      />

      <Modal
        title={t("Task Details")}
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        footer={null}
        width={520}
        rootClassName="task-details-modal"
        centered
      >
        <div className="task-details__head">
          <h2 className="task-details__title">{item?.title}</h2>
          <div className="task-details__tags">
            {priorityTag}
            {statusTag}
          </div>
        </div>

        <InfoRow icon={<UserOutlined />} label={t("Leader")}>
          <div className="task-details__inline">
            <Avatar
              size={28}
              icon={<UserOutlined />}
              style={{ backgroundColor: token.colorPrimary, flexShrink: 0 }}
            />
            <span className="task-details__strong">
              {item?.leader?.firstName} {item?.leader?.lastName}
            </span>
          </div>
        </InfoRow>

        <InfoRow icon={<FlagOutlined />} label={t("Priority & Status")}>
          <div className="task-details__inline">
            {priorityTag}
            {statusTag}
          </div>
        </InfoRow>

        <InfoRow icon={<CalendarOutlined />} label={t("Start Date")}>
          <span className="task-details__strong">{formatTaskDate(item?.startDate)}</span>
        </InfoRow>

        <InfoRow icon={<TeamOutlined />} label={t("Team Members")}>
          <div className="task-details__inline">
            <Avatar.Group
              max={{
                count: 5,
                style: {
                  color: token.colorPrimary,
                  backgroundColor: token.colorPrimaryBg,
                  fontWeight: 700,
                  fontSize: 11
                }
              }}
            >
              {item?.team?.map((pic, i) => (
                <Avatar
                  key={i}
                  size={34}
                  src={pic?.picture?.url}
                  icon={<UserOutlined />}
                  style={{
                    border: `2px solid ${token.colorBgContainer}`,
                    backgroundColor: token.colorPrimaryBorder
                  }}
                />
              ))}
            </Avatar.Group>
            <span className="task-details__muted">
              {item?.team?.length || 0} {t("Team Members")}
            </span>
          </div>
        </InfoRow>

        {item?.description && (
          <InfoRow icon={<FileTextOutlined />} label={t("Description")}>
            <p className="task-details__text">{item?.description}</p>
          </InfoRow>
        )}
      </Modal>
    </>
  );
};

export default ShowDrawer;
